import React from "react";
import BookingTicket from "../components/BookingTicket";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import LoaderOverlay from "../../../layout/components/LoaderOverlay";

interface ConfirmationStepProps {
  onAddAnotherEquipment: () => void;
}

function ConfirmationStep({ onAddAnotherEquipment }: ConfirmationStepProps) {
  const reservations = useSelector(
    (state: RootState) => state.bookingCreation.reservations
  )!;
  const location = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  )!;
  const isLoading = !(location && reservations.length > 0);

  return (
    <>
      {isLoading ? (
        <LoaderOverlay open={isLoading} />
      ) : (
        <div className="flex flex-col justify-between h-full">
          <div className="overflow-auto flex-grow">
            <BookingTicket
              location={location.name}
              reservations={reservations}
              amount={1}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default ConfirmationStep;
